<template>
    <div class="outer-wrapper">
       <div class="quick-nav">
            
            <div class="qn-content">
			<ul>
				<li class="qn-li">
					<a class="" href="service/report_query">
						报告查询
					</a>
				</li>
				<li class="qn-li">
					<a class="" href="service/order_do">
						检测委托
					</a>
				</li>
				<li class="qn-li">
					<a class="" href="service/product_represent">
						服务项目
					</a>
				</li>
				<li class="qn-li">
					<a class="" href="service/certificate_download">
						资质证书
					</a>
				</li>
				<li class="qn-li">
					<a class="" href="about_us" target="_blank">
						关于我们
					</a>
				</li>
			</ul>
		</div>
        </div>
    </div>

</template>
<script>
    export default {
        name: "quickNav",
        data() {
            return {
                items: [process.env.BASE_URL + "img/banner1.jpg",
                process.env.BASE_URL + "img/banner2.jpg",
                process.env.BASE_URL + "img/banner3.jpg",
                process.env.BASE_URL + "img/banner4.jpg",
                ],
            }
        },
        methods: {

        },
    }
</script>
<style scoped>
a {
        color: inherit;
    }

    a:hover {
        color: inherit;
    }



    a:active {
        color: inherit;
    }
    .quick-nav{
    width: 100%;
    height: 98px;
    background: #dc1e32;
    z-index: 9;
    margin-top: 0px;
}

.qn-content {
    width: 1280px;
    margin: 0 auto;
    height: 100%;
}

.qn-li {
    float: left;
    width:20%;
    text-align: center;
    line-height:98px;
    font-size:16px;
    color:#fff;
    font-weight: 550;
    letter-spacing: 1px;
}

.qn-li:hover{
    background-color: #fff;
    color:#dc1e32;
}
ul,li{
    list-style: none;
}
</style>